import { styled } from "@mui/material";
import { Card, Typography, Chip } from "@mui/material";
import { getResponseStatusAvatarBgColor } from './statusUtils';
export const StyledCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
  borderRadius: 8,
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  paddingBottom: theme.spacing(0.75),
  marginBottom: theme.spacing(1.5),
  fontWeight: "bold",
}));

export const ValueText = styled(Typography)({
  fontWeight: 500,
});

export const StatusChip = styled(Chip)(({ theme, status }) => {
  let color = getResponseStatusAvatarBgColor(status)
  // switch (status) {
  //   case "compliant":
  //     color = theme.palette.success.main;
  //     break;
  //   case "incompliant":
  //     color = theme.palette.error.main;
  //     break;
  //   case "pending":
  //     color = theme.palette.warning.main;
  //     break;
  //   default:
  //     color = theme.palette.grey[500];
  // }
  return {
    backgroundColor: color,
    color: "#fff",
    fontWeight: "bold",
    '& .MuiSvgIcon-root': {
      marginRight: 4
    }
  };
});